import { render, staticRenderFns } from "./ChatFullVideo.vue?vue&type=template&id=26561994"
import script from "./ChatFullVideo.vue?vue&type=script&lang=js"
export * from "./ChatFullVideo.vue?vue&type=script&lang=js"
import style0 from "./ChatFullVideo.vue?vue&type=style&index=0&id=26561994&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports